import React from 'react';
import { Paper } from '@material-ui/core';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

const NotFound = (props) => {
    const { classes } = props;
    return (
        <Paper elevation={0}>
            <div className={classes.notFound}>
                <div className={classes.notFound404}>
                    <h1 className={classes.type1}>
                        4<span className={classes.type2}>0</span>4
                    </h1>
                </div>
                <h2 className={classes.description}>The page you requested could not found</h2>
            </div>
        </Paper>
    );
};

NotFound.propTypes = {
    classes: PropTypes.object.isRequired,
};

const styles = () => ({
    notFound: {
        margin: '0 auto',
        width: '100%',
        lineHeight: '1.4',
        padding: '110px 40px',
        textAlign: 'center',
        background: '#fff',
    },

    notFound404: {
        position: 'relative',
        height: '250px',
    },

    type1: {
        fontFamily: "'Roboto', sans-serif",
        position: 'absolute',
        left: '50%',
        top: '50%',
        WebkitTransform: 'translate(-50%, -50%)',
        MsTransform: 'translate(-50%, -50%)',
        transform: 'translate(-50%, -50%)',
        fontSize: '165px',
        fontWeight: '700',
        margin: '0px',
        color: '#262626',
        textTransform: 'uppercase',
    },

    type2: {
        color: '#00b7ff',
    },

    description: {
        fontFamily: "'Roboto', sans-serif",
        fontSize: '22px',
        fontWeight: '400',
        textTransform: 'uppercase',
        color: '#151515',
        marginTop: '0px',
        marginBottom: '25px',
    },
});

export default withStyles(styles)(NotFound);
